
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLimitsInside as ObiLimitsInsideElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-limits-inside.js';
 
 
 

 
 export const ObiLimitsInside = createComponent({
   react: React,
   tagName: 'obi-limits-inside',
   elementClass: ObiLimitsInsideElement,
   events: {
     
   }
  });
 
 